import { render, staticRenderFns } from "./CardInformacoesPlanoCliente.vue?vue&type=template&id=f9892382&scoped=true&"
import script from "./CardInformacoesPlanoCliente.vue?vue&type=script&lang=js&"
export * from "./CardInformacoesPlanoCliente.vue?vue&type=script&lang=js&"
import style0 from "./CardInformacoesPlanoCliente.vue?vue&type=style&index=0&id=f9892382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9892382",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardText,VRow,VSkeletonLoader})
